import { fadeInUp } from "./Animations.styles";
import styled from "styled-components";

export const CalendarSection = styled.div`
    background: rgba(255, 255, 255, 0.95);
    padding: 12px;
    border-radius: 8px;
    border: none;
    margin-bottom: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s;
    animation: ${fadeInUp} 0.5s ease-out;

    &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }
`;

export const DateSelector = styled.div`
    background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
    border-radius: 8px;
    padding: 8px;
    color: #1f2937;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(209, 213, 219, 0.6);
`;

export const DateDisplay = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
`;

export const DateTextWrapper = styled.div`
    flex: 1;
    text-align: center;
`;

export const NavigationButton = styled.button`
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(209, 213, 219, 0.6);
    border-radius: 6px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #374151;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: white;
        border-color: #9ca3af;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:active {
        background: #f3f4f6;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }

    svg {
        font-size: 18px;
    }
`;

export const QuickButtons = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
`;

export const QuickButton = styled.button`
    background: ${(props) =>
        props.active ? "white" : "rgba(255, 255, 255, 0.6)"};
    border: 1px solid
        ${(props) => (props.active ? "#9ca3af" : "rgba(209, 213, 219, 0.6)")};
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 11px;
    color: ${(props) => (props.active ? "#1f2937" : "#4b5563")};
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: ${(props) => (props.active ? "600" : "400")};
    box-shadow: ${(props) =>
        props.active ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none"};

    &:hover {
        background: white;
        border-color: #9ca3af;
        color: #1f2937;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }
`;
